import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { SylBreadcrumb } from "../components/SylBreadcrumb";
import { SylExplainer } from "../components/SylExplainer";
import { SyllableCounter } from "../components/SyllableCounter";
import { SylMoreLinks } from "../components/SylMoreLinks";

export function SyllableCounterIndex() {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <SylBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.syl_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.syl_hub_intro()}
          </p>
        </header>

        <SyllableCounter />

        <SylExplainer
          howTo={m.syl_hub_howto()}
          faqs={[
            { q: m.syl_hub_faq1_q(), a: m.syl_hub_faq1_a() },
            { q: m.syl_hub_faq2_q(), a: m.syl_hub_faq2_a() },
            { q: m.syl_hub_faq3_q(), a: m.syl_hub_faq3_a() },
            { q: m.syl_hub_faq4_q(), a: m.syl_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />

        <SylMoreLinks current="hub" />
      </div>
    </div>
  );
}
